<template>
  <section>
    <p>CDR</p>
    <activity-overview :innerTabHeaders="innerTabHeaders" :type="type" />
  </section>
</template>

<script>
/**
 * @author Abraham Correa
 */
import ActivityOverview from "@/components/Agents/ActivityOverview/CDR";
export default {
  components: {
    ActivityOverview,
  },
  data() {
    return {
      innerTabHeaders: ["Entrantes", "Salientes"],
      type: "CDR",
    };
  },
};
</script>

<style>
</style>